


// import React from 'react';
// import toast from 'react-hot-toast';

// const MAX_FILE_SIZE_MB = 5; // Set limit here (change to 10 if needed)
// const MAX_FILE_SIZE = MAX_FILE_SIZE_MB * 1024 * 1024;

// const Step2UploadDocs = ({ data, setData, onNext, onBack }) => {
//   const handleFileChange = (e) => {
//     const { name, files } = e.target;

//     if (!files.length) return;

//     if (name === 'banner') {
//       if (files.length > 5) {
//         toast.error('You can upload up to 5 banner images.');
//         return;
//       }

//       // Check all banner images for size
//       const oversized = Array.from(files).filter(file => file.size > MAX_FILE_SIZE);
//       if (oversized.length > 0) {
//         toast.error(`Each banner image must be less than ${MAX_FILE_SIZE_MB}MB.`);
//         return;
//       }

//       setData({ ...data, [name]: Array.from(files) });
//     } else {
//       const file = files[0];

//       if (file.size > MAX_FILE_SIZE) {
//         toast.error(`${name} must be less than ${MAX_FILE_SIZE_MB}MB.`);
//         return;
//       }

//       setData({ ...data, [name]: file });
//     }
//   };

//   const validate = () => {
//     const requiredFiles = ['logo', 'banner', 'registrationCert', 'affiliationLetter', 'principalID', 'panCard'];

//     for (let file of requiredFiles) {
//       if (!data[file] || (file === 'banner' && (!Array.isArray(data.banner) || data.banner.length === 0))) {
//         toast.error(`Please upload: ${file}`);
//         return false;
//       }
//     }

//     return true;
//   };

//   const handleNext = () => {
//     if (validate()) onNext();
//   };

//   const renderFileLabel = (label, name, required = false, multiple = false) => (
//     <div className="w-full">
//       <label className="block text-sm font-medium text-gray-300 mb-1">
//         {label} {required && <span className="text-red-500">*</span>}
//       </label>
//       <input
//         type="file"
//         name={name}
//         onChange={handleFileChange}
//         multiple={multiple}
//         className="w-full file:mr-4 file:py-2 file:px-4
//                    file:rounded-lg file:border-0
//                    file:text-sm file:font-semibold
//                    file:bg-indigo-600 file:text-white
//                    hover:file:bg-indigo-700
//                    bg-slate-800 text-gray-300 border border-slate-600 rounded-lg cursor-pointer"
//       />
//       {data[name] &&
//         (Array.isArray(data[name]) ? (
//           <ul className="text-xs text-green-400 mt-1 list-disc pl-5 space-y-0.5">
//             {data[name].map((file, idx) => (
//               <li key={idx}>✔ {file.name}</li>
//             ))}
//           </ul>
//         ) : (
//           <p className="text-xs text-green-400 mt-1">✔ {data[name]?.name}</p>
//         ))}
//       <p className="text-xs text-gray-400 mt-1">Max file size: {MAX_FILE_SIZE_MB}MB</p>
//     </div>
//   );

//   return (
//     <div className="space-y-6">
//       {/* Section Title */}
//       <div className="text-center mb-6">
//         <h3 className="text-xl font-semibold text-white">Step 2: Upload Documents</h3>
//         <p className="text-gray-400 text-sm">Please upload all required documents for verification and branding.</p>
//       </div>

//       {/* Upload Fields Grid */}
//       <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//         {renderFileLabel("School Logo", "logo", true)}
//         {renderFileLabel("School Banner (up to 5 images)", "banner", true, true)}
//         {renderFileLabel("Registration Certificate", "registrationCert", true)}
//         {renderFileLabel("Affiliation Letter", "affiliationLetter", true)}
//         {renderFileLabel("Principal's ID Proof", "principalID", true)}
//         {renderFileLabel("School PAN Card", "panCard", true)}
//       </div>

//       {/* Navigation Buttons */}
//       <div className="flex justify-between pt-6">
//         <button
//           onClick={onBack}
//           className="px-6 py-2 bg-gray-600 hover:bg-gray-700 text-white font-semibold rounded-lg transition duration-200 shadow-md"
//         >
//           ← Back
//         </button>
//         <button
//           onClick={handleNext}
//           className="px-6 py-2 bg-indigo-600 hover:bg-indigo-700 text-white font-semibold rounded-lg transition duration-200 shadow-md"
//         >
//           Next Step →
//         </button>
//       </div>
//     </div>
//   );
// };

// export default Step2UploadDocs;


import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';

const MAX_FILE_SIZE_MB = 5;
const MAX_FILE_SIZE = MAX_FILE_SIZE_MB * 1024 * 1024;

const Step2UploadDocs = ({ data, setData, onNext, onBack }) => {
  const [previews, setPreviews] = useState({});

  // Generate image previews
  useEffect(() => {
    const newPreviews = {};
    for (const key in data) {
      const value = data[key];
      if (value) {
        if (Array.isArray(value)) {
          newPreviews[key] = value.map(file => URL.createObjectURL(file));
        } else if (value.type?.startsWith("image/")) {
          newPreviews[key] = URL.createObjectURL(value);
        }
      }
    }

    setPreviews(newPreviews);

    return () => {
      // Cleanup object URLs
      Object.values(newPreviews).flat().forEach(url => URL.revokeObjectURL(url));
    };
  }, [data]);

  const handleFileChange = (e) => {
    const { name, files } = e.target;

    if (!files.length) return;

    if (name === 'banner') {
      if (files.length > 5) {
        toast.error('You can upload up to 5 banner images.');
        return;
      }

      const oversized = Array.from(files).filter(file => file.size > MAX_FILE_SIZE);
      if (oversized.length > 0) {
        toast.error(`Each banner image must be less than ${MAX_FILE_SIZE_MB}MB.`);
        return;
      }

      setData({ ...data, [name]: Array.from(files) });
    } else {
      const file = files[0];

      if (file.size > MAX_FILE_SIZE) {
        toast.error(`${name} must be less than ${MAX_FILE_SIZE_MB}MB.`);
        return;
      }

      setData({ ...data, [name]: file });
    }
  };

  const validate = () => {
    const requiredFiles = ['logo', 'banner', 'registrationCert', 'affiliationLetter', 'principalID', 'panCard'];

    for (let file of requiredFiles) {
      if (!data[file] || (file === 'banner' && (!Array.isArray(data.banner) || data.banner.length === 0))) {
        toast.error(`Please upload: ${file}`);
        return false;
      }
    }

    return true;
  };

  const handleNext = () => {
    if (validate()) onNext();
  };

  const renderImagePreview = (name) => {
    if (!previews[name]) return null;

    if (Array.isArray(previews[name])) {
      return (
        <div className="flex flex-wrap gap-2 mt-2">
          {previews[name].map((url, idx) => (
            <img
              key={idx}
              src={url}
              alt={`Preview ${idx}`}
              className="h-16 w-28 object-cover rounded border border-gray-600"
            />
          ))}
        </div>
      );
    } else {
      return (
        <img
          src={previews[name]}
          alt="Preview"
          className="h-16 w-28 object-cover rounded mt-2 border border-gray-600"
        />
      );
    }
  };

  const renderFileLabel = (label, name, required = false, multiple = false) => (
    <div className="w-full">
      <label className="block text-sm font-medium text-gray-300 mb-1">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      <input
        type="file"
        name={name}
        onChange={handleFileChange}
        multiple={multiple}
        accept="image/*"
        className="w-full file:mr-4 file:py-2 file:px-4
                   file:rounded-lg file:border-0
                   file:text-sm file:font-semibold
                   file:bg-indigo-600 file:text-white
                   hover:file:bg-indigo-700
                   bg-slate-800 text-gray-300 border border-slate-600 rounded-lg cursor-pointer"
      />
      {data[name] &&
        (Array.isArray(data[name]) ? (
          <ul className="text-xs text-green-400 mt-1 list-disc pl-5 space-y-0.5">
            {data[name].map((file, idx) => (
              <li key={idx}>✔ {file.name}</li>
            ))}
          </ul>
        ) : (
          <p className="text-xs text-green-400 mt-1">✔ {data[name]?.name}</p>
        ))}
      <p className="text-xs text-gray-400 mt-1">Max file size: {MAX_FILE_SIZE_MB}MB</p>
      {renderImagePreview(name)}
    </div>
  );

  return (
    <div className="space-y-6">
      {/* Section Title */}
      <div className="text-center mb-6">
        <h3 className="text-xl font-semibold text-white">Step 2: Upload Documents</h3>
        <p className="text-gray-400 text-sm">Please upload all required documents for verification and branding.</p>
      </div>

      {/* Upload Fields Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {renderFileLabel("School Logo", "logo", true)}
        {renderFileLabel("School Banner (up to 5 images)", "banner", true, true)}
        {renderFileLabel("Registration Certificate", "registrationCert", true)}
        {renderFileLabel("Affiliation Letter", "affiliationLetter", true)}
        {renderFileLabel("Principal's ID Proof", "principalID", true)}
        {renderFileLabel("School PAN Card", "panCard", true)}
      </div>

      {/* Navigation Buttons */}
      <div className="flex justify-between pt-6">
        <button
          onClick={onBack}
          className="px-6 py-2 bg-gray-600 hover:bg-gray-700 text-white font-semibold rounded-lg transition duration-200 shadow-md"
        >
          ← Back
        </button>
        <button
          onClick={handleNext}
          className="px-6 py-2 bg-indigo-600 hover:bg-indigo-700 text-white font-semibold rounded-lg transition duration-200 shadow-md"
        >
          Next Step →
        </button>
      </div>
    </div>
  );
};

export default Step2UploadDocs;


